import { IBaseWidget } from '../../widgets/IBaseWidget';
import { IPdfVisibilityDirective } from './IPdfVisibilityDirective';

/**
 * Estrae e tipizza la configurazione della direttiva
 * di visibilità per i pdf dal widget
 */
export function extractPdfVisibility(
  widget: IBaseWidget,
): IPdfVisibilityDirective | undefined {
  return widget.directives?.pdfVisibility;
}
